import styled from "@emotion/styled"
import { Flex } from "@rebass/grid/emotion"

import theme from "@nutrafol/nutrafol-ui-kit/styles/theme"

export const OptionsWrapper = styled.div`
  border-radius: 4px;
  overflow: hidden;

  &.multiple-options:not(.seperate-options) {
    border: 1px solid ${theme.wild.color.nova.transparency.black[20]};
  }
`

export const OptionButton = styled(Flex)`
  width: 100%;
  text-align: left;
  padding: 16px;

  .flex-title {
    gap: 4px;
    @media (min-width: 360px) {
      gap: 8px;
    }
  }

  &.single-option {
    cursor: default;
  }

  .text_description {
    @media (max-width: 480px) {
      max-width: 200px;
    }
  }

  &:not(:last-child) {
    border-bottom: 1px solid ${theme.wild.color.nova.transparency.black[20]};
  }

  &.active {
    background: ${theme.wild.color.nova.base.solid[20]};
  }

  &.seperate-option {
    margin-bottom: 8px;
    border: 1px solid ${theme.wild.color.nova.transparency.black[20]};
    border-radius: 4px;
  }

  &.has-banner {
    border-top-left-radius: 0;
    border-top-right-radius: 0;
    border-top: 0;
  }

  .tag {
    height: 20px;
    display: flex;
    align-items: center;

    > span {
      top: 1px;
    }
    @media (min-width: 767px) {
      height: 24px;
    }
  }
`

export const Banner = styled.div`
  background: ${theme.wild.color.nova.brand.primary[80]};
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  padding: 8px;
  text-align: center;

  .textelement.nova[class*="Caption-"][class*="-Uppercase"] {
    line-height: 1;
  }
`

export const RadioButton = styled.div`
  width: 16px;
  height: 16px;
  border-radius: 50%;
  border: 1px solid ${theme.wild.color.nova.transparency.black[40]};

  &.active {
    border: 5px solid ${theme.wild.color.nova.brand.primary[80]};
  }
`
